import React from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Divider,
  useTheme,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const UserDeactivated = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 6,
          px: 2,
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 500,
            boxShadow: 5,
            borderRadius: 3,
            textAlign: "center",
            p: 3,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <CardContent>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: theme.palette.error.main,
                mb: 1,
              }}
            >
              Account Deactivated
            </Typography>

            <Typography variant="body1" sx={{ color: theme.palette.text.secondary, mb: 1.5 }}>
              Your account has been deactivated. You cannot access the application at this time.
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 3 }}>
              Please contact your administrator for assistance.
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: theme.palette.primary.main,
                mb: 2,
              }}
            >
              Admin Contact
            </Typography>

            <Box sx={{ textAlign: "left", pl: 4 }}>
              <Typography variant="body1">
                <strong>Name:</strong> BJS Admin
              </Typography>
              <Typography variant="body1">
                <strong>Email:</strong> info@bjsindia.org
              </Typography>
              <Typography variant="body1">
                <strong>Phone:</strong> +91 9545111551
              </Typography>
            </Box>

            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              sx={{
                mt: 3,
                backgroundColor: theme.palette.primary.main,
                "&:hover": {
                  backgroundColor: theme.palette.primary.dark,
                },
              }}
              onClick={() => navigate("/")}
            >
              Go to Home
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default UserDeactivated;